
import Vue, { PropType } from 'vue'
import Opz2Cards from './Opz2Cards.vue'
import Opz2Table from './Opz2Table.vue'
import Opz2DetailTable from './Opz2DetailTable.vue'
import { Report, Row, StaffFlag, cnt, fnPct, staffLabel } from './model'

/**
 * Таблица по мастерам — stat_by_staff / stat_by_staff_total по всем ОПЗ.
 * Карточки повторяют итог этой таблицы (stat_by_staff_total) и от кнопок не зависят.
 * Детализация — same_spec_details с фильтром flag_record_same_staff функции.
 */
export default Vue.extend({
    name: 'Opz2OpzPane',
    components: { Opz2Cards, Opz2Table, Opz2DetailTable },
    props: {
        report: { type: Object as PropType<Report>, required: true },
        emptyLabel: { type: String, default: 'В этом периоде нет визитов' },
    },
    data: () => ({
        staffFlags: [
            { id: 'all', label: 'Все ОПЗ' },
            { id: 'same_staff', label: 'К тому же мастеру' },
            { id: 'other_staff', label: 'К другому мастеру' },
        ] as Array<{ id: StaffFlag; label: string }>,
        masterColumns: [
            { label: 'Мастер исходного визита', key: 'master', width: 192 },
            { label: 'Визитов', key: 'visits_cnt', cls: 'num', width: 95 },
            { label: 'ОПЗ создано', key: 'recorded_same_spec_cnt', cls: 'num', width: 112 },
            { label: 'К тому же мастеру', key: 'recorded_same_spec_and_staff_cnt', cls: 'num', width: 124 },
            { label: 'К другому мастеру', key: 'recorded_same_spec_other_staff_cnt', cls: 'num', width: 128 },
            { label: 'Ожидается', key: 'recorded_same_spec_future_cnt', cls: 'num', width: 109 },
            { label: 'Завершено', key: 'recorded_same_spec_success_cnt', cls: 'num', width: 106 },
            { label: 'Отменено', key: 'recorded_same_spec_cancel_cnt', cls: 'num', width: 100 },
            {
                label: 'Доля ОПЗ от визитов',
                key: 'recorded_same_spec_opz_conv',
                cls: 'num',
                cellCls: 'num value-indigo',
                width: 139,
                pct: true,
            },
        ] as any[],
    }),
    computed: {
        total(): Row {
            return this.report.staffStat.total
        },
        masters(): Row[] {
            return this.report.staffStat.rows.map(row => ({
                ...row,
                master: staffLabel(this.report, row.staff_id),
            }))
        },
        selection(): Report['staffSelection'] {
            return this.report.staffSelection
        },
        selectionRows(): Row[] {
            return this.selection.rows
        },
        cards(): any[] {
            const t = this.total
            return [
                {
                    label: 'ОПЗ создано',
                    value: cnt(t.recorded_same_spec_cnt),
                    note: `${cnt(t.recorded_same_spec_active_cnt)} записей без отмен`,
                    color: 'indigo',
                },
                {
                    label: 'Ожидается визит',
                    value: cnt(t.recorded_same_spec_future_cnt),
                    note: 'Следующий визит ещё впереди',
                    color: 'amber',
                },
                {
                    label: 'Визитов завершено',
                    value: cnt(t.recorded_same_spec_success_cnt),
                    note: 'Клиенты уже пришли',
                    color: 'teal',
                },
                {
                    label: 'Отменено',
                    value: cnt(t.recorded_same_spec_cancel_cnt),
                    note: `${fnPct(t.recorded_same_spec_cancel_percent)} от всех ОПЗ`,
                    color: 'red',
                },
            ]
        },
    },
    methods: { cnt, fnPct },
})
